<template>
	<!-- `teaser` is a styling hook (styled in aworldofcraft). -->
	<div v-editable="blok" class="teaser py-32 text-6xl font-bold text-center">
		{{ blok.headline }}
	</div>
</template>

<script setup lang="ts">
import type { BlokTeaser } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokTeaser;
}
const { blok } = defineProps<Props>();
</script>
